export default __webpack_public_path__ + "static/media/commercial-slider-placeholder.dfee8192.png";